export * from './catalog-layer-item.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/catalog/catalog-layer-item/index.ts